// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;

// Pre-requisites.
// Add a Woocommerce "Cart" widget to the Mini-Cart sidebar in Wordpress Admin.


// To understand how the mini cart works you will want to view these files in Woocommerce to see the events that fire:
//
// /woocommerce/assets/js/frontend/cart-fragments.js
// /woocommerce/assets/js/frontend/add-to-cart.js
// /woocommerce/assets/js/frontend/cart.js (this is the full cart js, but it might serve as reference)

// You will also want to check out the html structure:
// /woocommerce/templates/cart/mini-cart.php
// /themes/emopress/inc/woocommerce-customisations.php (this is where it gets initialised)


// TODO: Improvements:
// - Test cart with wishlist to make sure no bugs arise
// - Use the jquery.blockUI plugin that is bundled with woocommerce?
// - The modal and API calls should be moved to their own modules.


const settings = {
    isOpenClass: 'is-open-navbar-offcanvas',
    isLoadingClass: 'is-loading',
    toggleSelectors: '.js-header-cart-link, .js-navbar-offcanvas-toggle, .js-overlay', // jquery selector (string), separate with a ", " all the selectors that should toggle the cart.
    containerSelector: '.mini-cart', // the container for the mini cart.
    classes: ''
};






// This will be moved to another file.


function modal (title, content) {


var template = `
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="exampleModalLabel">${title}</h4>
      </div>
      <div class="modal-body">
         ${content}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>`;

    var element = $(template);

    $(document.body).append(element);
    element.modal();

}





export default class {

    // Starts here.
    constructor() {
        this.setInitialState();
        this.setCache();
        this.makeOffcanvas();
        this.bindEvents();
    }


    // set a state object (for checking different states the mini-cart might have)
    setInitialState() {
        this.state = {
            isOpen: false,
            isLoading: false,
        };
    }

    // cache DOM elements when possible for performance
    setCache () {
        this.cache = {};
        this.cache.container = $(settings.containerSelector);

        // stop if the mini-cart doesn't even exist
        if (this.cache.container.length) {
            this.cache.body = $(document.body); // lots of woocommerce events get fired here.
        }
    }


    // bind the different events that interact with the component
    bindEvents () {

        // no use binding if doesn't exist
        if (this.cache.container.length) {

            // optionally, if you have a toggle cart link somewhere, this will activate it.
            if (settings.toggleSelectors) {
                this.cache.body.on('click', settings.toggleSelectors, this.toggle.bind(this));
            }

        }
    }

    makeOffcanvas() {
        // modal("hello", "content");
    }




    // alias for toggle, but always true.
    open() {
        this.toggle(true);
    }

    // alias for toggle, but always false.
    close() {
        this.toggle(false);
    }

    // open/close the Offcanvas.
    toggle (value) {

        if ("boolean" !== (typeof(value))) {
            // if an event is passed in instead of a boolean, it will prevent default and try to get a data value from the event.
            if (value.target) {
                var event = value;
                event.preventDefault();
                value = event.data;
            }

            // if you didn't pass in a boolean with the event, it will check the Mini Offcanvass current state and toggle it.
            if ("boolean" !== (typeof(value))) {
                value = !this.state.isOpen;
            }
        }

        this.cache.body.toggleClass(settings.isOpenClass, value);

        // update a boolean on this object so that we can check the state if needed.
        this.state.isOpen = value;
    }

}